import { useEffect } from 'react';
import { Card, Table } from 'react-bootstrap';
import { FaBan, FaCheck } from 'react-icons/fa';

const InfoCotisation = ({ cotisation, choix_id, paiement_en_x_fois }) => {

    useEffect(() => {
        console.log('cotisation', cotisation);
    }
        , [cotisation]);

    const ExpandedComponent = () => {

        let myChoix = JSON.parse(cotisation.choix);

        return <Card>
            <Card.Header>Choix de cotisation</Card.Header>
            {/* <Card.Body> */}
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                        {cotisation.trois_fois === 1 && <th>En 3 fois</th>}
                        {cotisation.six_fois === 1 && <th>En 6 fois</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.map((e) => (
                            <tr>
                                {/* <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.libelle}</td>
                                <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.montant}&nbsp;€</td>
                                {cotisation.trois_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                {cotisation.six_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{Math.ceil(e.montant / 6)}&nbsp;€</td>} */}

                                <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.libelle} - {paiement_en_x_fois}</td>
                                <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 1 ? 'lightblue' : 'bisque') : '' }}>{e.montant}&nbsp;€</td>
                                {cotisation.trois_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 3 ? 'lightblue' : 'bisque') : '' }}>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                {cotisation.six_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 6 ? 'lightblue' : 'bisque') : '' }}>{Math.ceil(e.montant / 6)}&nbsp;€</td>}
                            </tr>
                        ))
                    }
                </tbody>
            </Table>

        </Card>
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    return (
        <Card>
            {cotisation && cotisation.choix && (<>
                <Card.Header>{cotisation.reference} - {cotisation.titre}</Card.Header>
                <Card.Body>
                    Libellé : {cotisation.libelle}<br />
                    Tribu montant : {cotisation.tribu_montant + ' €'}<br />
                    Trois fois : {cotisation.trois_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />}<br />
                    Six fois : {cotisation.six_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />}<br />
                    <br />
                    {ExpandedComponent()}
                </Card.Body>
            </>)}
        </Card>
    );
}

export default InfoCotisation;
